'use client'
import { useLocale, useTheme, useTranslation } from '@payloadcms/ui'
import clsx from 'clsx'
import Image from 'next/image'
import React from 'react'

interface Props {
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
}

export const BeforeNavLink = (props: Props) => {
  const { loading: loadingFromProps, priority: priorityFromProps, className } = props

  const loading = loadingFromProps || 'lazy'
  const priority = priorityFromProps || 'low'
  const { theme } = useTheme()

  const { i18n } = useTranslation()
  const locale = i18n.language

  const isArabic = locale === 'ar'
  const logoSrc =
    theme === 'dark'
      ? isArabic
        ? '/ArabicWhiteLogo.png'
        : '/SOUKNA-WHITE.png'
      : isArabic
        ? '/ArabicBlackLogo.png'
        : '/SOUKNA-BLACK.png'

  return (
    /* eslint-disable @next/next/no-img-element */
    <Image
      alt="Soukna Logo"
      width={120}
      height={44}
      // loading={loading}
      // fetchPriority={priority}
      decoding="async"
      className={clsx('!w-[138px] !h-[44px] !mb-[25px]', className)}
      style={{ 
        marginRight: isArabic ? '24px' : '0px',
        marginLeft: isArabic ? '0px' : '24px',
       }}
      src={logoSrc}
    />
  )
}
